import { useState, useEffect } from "react";
import { Loader2, History } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/admin/ui";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

const Activity = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/activity").then((r) => setItems(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Centro de actividades" subtitle="Historial de acciones administrativas" />
      {loading ? <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-indigo-600" /></div>
        : items.length === 0 ? <EmptyState icon={History} text="Sin actividad registrada." />
        : (
          <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
            {items.map((a) => (
              <div key={a.id} className="flex items-start gap-3 p-4" data-testid={`activity-${a.id}`}>
                <div className="h-8 w-8 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0"><History className="h-4 w-4 text-indigo-600" /></div>
                <div className="min-w-0">
                  <p className="text-sm text-slate-800"><span className="font-semibold">{a.user}</span> · {a.action.replace(/_/g, " ")}</p>
                  {a.detail && <p className="text-xs text-slate-500">{a.detail}</p>}
                  <p className="text-xs text-slate-400 mt-0.5">{formatDateTime(a.created_at)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default Activity;
